export function getAuthHeader(): string | null {
  const token = localStorage.getItem('token');
  return token ? `Bearer ${token}` : null;
}

export function getToken(): string | null {
  return localStorage.getItem('token');
}

export function getUserId(): string | null {
  const user = localStorage.getItem('user');
  if (user) {
    try {
      const parsed = JSON.parse(user);
      return parsed.id || parsed._id || parsed.userId;
    } catch {
      return null;
    }
  }
  return null;
}

export function getEventId(): string | null {
  const params = new URLSearchParams(window.location.search);
  return params.get('eventoId') || localStorage.getItem('currentEventId');
}

export function getUserProfile(): string | null {
  const user = localStorage.getItem('user');
  if (user) {
    try {
      const parsed = JSON.parse(user);
      return parsed.profile || parsed.role || 'admin';
    } catch {
      return 'admin';
    }
  }
  return 'admin';
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem('token');
}

export function clearAuth(): void {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('currentEventId');
}